const apiBaseUrl =  'https://api.psexpofab.com'
const imageBaseurl =  'https://api.psexpofab.com/uploads/'
// const apiBaseUrl = 'http://localhost:5000'
// const imageBaseurl = 'http://localhost:5000/uploads/'

const localhostKey = {
  token: 'at'
}

export const siteData = {
  name: "P.S. Expo Fab",
}

const pageRoute = {
  login: "/login",
  signUp: '/sign-up',
  profile: '/profile',
  newsLatter: '/news-latter',
  contactUsList: '/contact-us-list',
}

const getImageFullUrl = (url) => {
  return imageBaseurl + url
}

export {
  apiBaseUrl, imageBaseurl, localhostKey, pageRoute, getImageFullUrl
}